<div class="rrss">
  <div class="sidebar-icon" (click)="mostrarRRSS()">
    <app-icon-share [selected]="rrssVisible" [shared]="true"></app-icon-share>
  </div>
  <div class="rrss_container" [style.display]="rrssVisible ? 'flex' : 'none'">
    <a href="https://www.facebook.com/sharer/sharer.php?u={{ url }}" target="_blank">
      <img src="assets/images/facebook.webp" alt="Facebook" class="icons" loading="lazy" />
    </a>
    <a href="https://twitter.com/intent/tweet?text={{ url }}" data-size="large" target="_blank">
      <img src="assets/images/x.webp" alt="Twitter" class="icons" loading="lazy" />
    </a>
    <a href="https://api.whatsapp.com/send?text={{ text }} - {{ url }}" data-action="share/whatsapp/share" target="_blank">
      <img src="assets/images/whatsapp.webp" alt="Whatsapp" class="icons" loading="lazy" />
    </a>
    <a href="https://www.linkedin.com/sharing/share-offsite/?url={{ text }} - {{ url }}" target="_blank">
      <img src="assets/images/linkedin.webp" alt="Linkedin" class="icons" loading="lazy" />
    </a>
  </div>
</div>
